import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useCookies } from 'react-cookie';

import security     from "~/services/security";
import getRecaptcha from "~/pages/Authentication/_services/recaptcha";

const GoogleCallback = ()=> {

  const [successfulLogin , setSuccessfulLogin] = useState({isLoading: true});
  const [banMessage      , setBanMessage     ] = useState("");
  const [cookies         , _, removeCookie   ] = useCookies();

  const getAuthTokenGoogle = (recaptcha, code)=> {
    const body = {
      ...{code: code.split("&scope")[0], referralCode : cookies.referral, recaptcha },
      ...(cookies.postbackTracking ? {postbackTracking: cookies.postbackTracking} : {})
    };
    return security.loginGoogle(body);
  };

  useEffect(()=> {

    if(!window.location.href.includes("code=")) return;

    const code = window.location.href.split("code=")[1];

    getRecaptcha().then((recaptcha)=> getAuthTokenGoogle(recaptcha, code))
      .then(()=> {
        removeCookie("postbackTracking", {
          domain   : process.env.REACT_APP_COOKIE_DOMAIN,
          path     : "/",
          sameSite : 'lax',
          secure   : true,
        });
        setSuccessfulLogin(true);
      }).catch((e)=> {
        console.log(e)
        if(e.status === 401) setBanMessage(e.data.error?.banMessage);
        setSuccessfulLogin(false);
      });
  }, []);

  if(successfulLogin.isLoading) return null;

  return successfulLogin
    ? <Redirect to={ {pathname: "/dashboard" }} />
    : <Redirect to={ {pathname: "/login"    , message: {text: "Google Authentication Failed", type: "error", banMessage }}} />
};

export default GoogleCallback;
